(function () {
  const tabs = document.querySelectorAll('.category-tab');
  const sections = document.querySelectorAll('.category-section');

  // Find the first visible tab and section
  //This code looks awkward, but when the first tab was invisible for the AR preview it was causing issues
  const firstVisibleTab = Array.from(tabs).find(tab => tab.offsetParent !== null);
  if (firstVisibleTab) {
    firstVisibleTab.classList.add('active');
    const category = firstVisibleTab.getAttribute('data-category');
    const firstVisibleSection = document.getElementById(category);
    if (firstVisibleSection) {
      firstVisibleSection.classList.add('active');
    }
  }

  // Add click event listener to tabs
  tabs.forEach(tab => {
    console.log(tab)
    tab.addEventListener('click', function() {
      let category = this.getAttribute('data-category');

      tabs.forEach(t => t.classList.remove('active'));
      sections.forEach(section => section.classList.remove('active'));

      this.classList.add('active');
      document.getElementById(category).classList.add('active');
    });
  });
})();